export default "__VITE_PUBLIC_ASSET__6759b700__"